<script>
	import Router from 'svelte-spa-router';
	import routes from '../alertRoutes.js';
	import PageHeader from '../components/PageHeader.svelte';
	import SideNav from '../components/SideNav.svelte';
  import PageFooter from '../components/PageFooter.svelte';

  const prefix = '/app'
</script>
<div class="container-scroller">
	<PageHeader></PageHeader>
	<div class="container-fluid page-body-wrapper">
		<SideNav></SideNav>
		<div class="main-panel">
			<div class="content-wrapper">
				<Router {routes} {prefix}/>
				<PageFooter></PageFooter>
			</div>
		</div>
	</div>
</div>